import { hasGraphqlErrorCode } from './hasGraphqlErrorCode'

/**
 * 403 として扱う code の集合。`FORBIDDEN` の下位区分 (ライセンス不足等) は message でなく別 code で表すため、
 * 汎用の 403 表示に乗せる code はここで 1 箇所に列挙する。code を増やしたら errorLink の既知 code にも追加する。
 */
const FORBIDDEN_CODES = ['FORBIDDEN', 'VISUALIZE_LICENSE_REQUIRED'] as const

export const isForbiddenError = (error: unknown): boolean => hasGraphqlErrorCode(error, FORBIDDEN_CODES)
